import React from 'react';

interface ISubtitleProps {
  children: React.ReactNode;
}

export const Subtitle: React.FC<ISubtitleProps> = ({ children }) => (
  <p className="tw-lf-body-bold-sm tw-mt-2">{children}</p>
);
